import { useQuery } from "react-query";

export function useAccountList() {
  return useQuery<{ userName: string; userId: number }[]>(
    "/api/rendering/task/renderingTask/loadingUserName"
  );
}
